import React from "react";
import { FaCalendarAlt, FaChair, FaCheckCircle, FaDoorOpen, FaFilter, FaLayerGroup, FaSearch, FaTimes } from "react-icons/fa";
import FormSelect from "../components/FormSelect.jsx";
import { useState } from "react";

const STATUS_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const SUBSCRIPTION_OPTIONS = [
  { value: "all", label: "All Types" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "half_yearly", label: "Half Yearly" },
  { value: "yearly", label: "Yearly" },
];

const PLAN_TYPE_OPTIONS = [
  { value: "all", label: "All Plans" },
  { value: "general", label: "General" },
  { value: "reserved", label: "Reserved" },
];

const SEAT_TYPE_OPTIONS = [
  { value: "all", label: "All Seat Types" },
  { value: "ac", label: "AC" },
  { value: "non_ac", label: "Non-AC" },
];

const ROWS_OPTIONS = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
];

export default function StudentFilters({
  searchTerm, setSearchTerm,
  filterStatus, setFilterStatus,
  filterRoom, setFilterRoom,
  filterSubscription, setFilterSubscription,
  filterPlanType, setFilterPlanType,
  filterSeatCategory, setFilterSeatCategory,
  rooms = [], filteredStudents = [], currentStudents = [], totalStudents = 0,
  currentPage, totalPages, itemsPerPage, handleItemsPerPageChange, clearFilters
}) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const roomOptions = [
    { value: "all", label: "All Rooms" },
    ...rooms.map(room => ({
      value: room.id || room.room_id,
      label: room.room_name || `Room ${room.id || room.room_id}`,
    })),
  ];

  const filtersActive = Boolean(String(searchTerm || "").trim())
    || filterStatus !== "all"
    || filterRoom !== "all"
    || filterSubscription !== "all"
    || filterPlanType !== "all"
    || filterSeatCategory !== "all";

  return (
    <>
      <div className="filter-toggle-row">
        <button type="button" className="filter-toggle-btn" aria-expanded={filtersOpen} aria-controls="student-filter-panel" onClick={() => setFiltersOpen(open => !open)}>
          <FaFilter aria-hidden="true" /><span>{filtersOpen ? "Hide filters" : "Show filters"}</span>
        </button>
      </div>

      {filtersOpen && <section id="student-filter-panel" className="panel student-filter-card is-open" aria-label="Student filters">
      <div className="student-filter-head">
        <div className="student-filter-title">
          <span className="student-filter-icon" aria-hidden="true"><FaFilter /></span>
          <div>
            <b>Filters</b>
            <small>Refine students by status, room, plan, or search term.</small>
          </div>
        </div>
        <span className="student-filter-count">
          <b>{filteredStudents.length}</b> of <b>{totalStudents}</b> students
        </span>
      </div>

      <div className="student-filter-controls">
        <label className="student-filter-search">
          <FaSearch aria-hidden="true" />
          <input
            type="text"
            placeholder="Search name, phone, or seat..."
            value={searchTerm}
            onChange={event => setSearchTerm(event.target.value)}
            aria-label="Search students"
          />
        </label>

        <FormSelect
          className="student-filter-select"
          ariaLabel="Filter by status"
          value={filterStatus}
          onChange={setFilterStatus}
          options={STATUS_OPTIONS}
          icon={<FaCheckCircle />}
        />

        <FormSelect
          className="student-filter-select"
          ariaLabel="Filter by room"
          value={filterRoom}
          onChange={setFilterRoom}
          options={roomOptions}
          icon={<FaDoorOpen />}
        />

        <FormSelect
          className="student-filter-select"
          ariaLabel="Filter by subscription"
          value={filterSubscription}
          onChange={setFilterSubscription}
          options={SUBSCRIPTION_OPTIONS}
          icon={<FaCalendarAlt />}
        />

        <FormSelect
          className="student-filter-select"
          ariaLabel="Filter by plan type"
          value={filterPlanType}
          onChange={setFilterPlanType}
          options={PLAN_TYPE_OPTIONS}
          icon={<FaLayerGroup />}
        />

        <FormSelect
          className="student-filter-select"
          ariaLabel="Filter by seat type"
          value={filterSeatCategory}
          onChange={setFilterSeatCategory}
          options={SEAT_TYPE_OPTIONS}
          icon={<FaChair />}
        />

        <button
          type="button"
          className="button ghost student-filter-clear"
          onClick={clearFilters}
          disabled={!filtersActive}
        >
          <FaTimes aria-hidden="true" />
          <span>Clear filters</span>
        </button>
      </div>

      <div className="student-filter-footer">
        <span>
          Showing <b>{currentStudents.length}</b> of <b>{filteredStudents.length}</b> filtered students
          {" "}(Page {currentPage} of {totalPages || 1})
        </span>
        <div className="student-rows">
          <span>Rows</span>
          <FormSelect
            className="student-rows-select"
            ariaLabel="Rows per page"
            value={itemsPerPage}
            onChange={value => handleItemsPerPageChange({ target: { value: String(value) } })}
            options={ROWS_OPTIONS}
          />
        </div>
      </div>
      </section>}
    </>
  );
}
